export default "__VITE_ASSET__CSMMzBfq__"